export default __webpack_public_path__ + "static/media/upload.941ae9e1.jpg";